import API from "@/api";
import TwilioChat from "twilio-chat";
import timeFormat from "@/utils/time/timeFormat";
import { authStore } from "@/mixins/authStoreMixin";
import { Client } from "@twilio/conversations";
import moment from "moment"
const twillioChannelEvents = {
  EVENT_MESSAGE_ADDED: "messageAdded",
  EVENT_TYPING_STARTED: "typingStarted",
  EVENT_TYPYING_ENDED: "typingEnded",
  EVENT_MEMBER_JOINED: "memberJoined",
  EVENT_MEMBER_LEFT: "memberLeft"
};

export const moduleName = "support";

export const actionTypes = {
  ACTION_CONNECT: "ACTION_CONNECT",
  ACTION_DISCONNECT: "ACTION_DISCONNECT",
  ACTION_FETCH_TOKEN: "ACTION_FETCH_TOKEN",
  ACTION_REFRESH_TOKEN: "ACTION_REFRESH_TOKEN",
  ACTION_LEAVE_CURRENT_CHANNEL: "ACTION_LEAVE_CURRENT_CHANNEL",
  ACTION_LOAD_MESSAGES: "ACTION_LOAD_MESSAGES",
  ACTION_SEND_MESSAGE: "ACTION_SEND_MESSAGE",
  ACTION_SELECT_CHANNEL: "ACTION_SELECT_CHANNEL",
  ACTION_DELETE_CHANNEL: "ACTION_DELETE_CHANNEL",
  ACTION_READ_MESSAGE: "ACTION_READ_MESSAGE",
  ACTION_FETCH_MANAGERS: "ACTION_FETCH_MANAGERS",
  ACTION_DELETE_MESSAGE: "ACTION_DELETE_MESSAGE"
};

export const mutationTypes = {
  MUTATION_ADD_MESSAGE: "MUTATION_ADD_MESSAGE",
  MUTATION_UNSET_MESSAGES: "MUTATION_UNSET_MESSAGES",
  MUTATION_SET_TYPING_MEMBER: "MUTATION_SET_TYPING_MEMBER",
  MUTATION_UNSET_TYPING_MEMBER: "MUTATION_UNSET_TYPING_MEMBER",
  MUTATION_SET_CHANNELS: "MUTATION_SET_CHANNELS",
  MUTATION_ADD_CHANNELS: "MUTATION_ADD_CHANNELS",
  MUTATION_SET_SELECTED_CHANNEL: "MUTATION_SET_SELECTED_CHANNEL",
  MUTATION_UPDATE_CHANNEL: "MUTATION_UPDATE_CHANNEL",
  MUTATION_ADD_MESSAGE_TO_CHANNEL: "MUTATION_ADD_MESSAGE_TO_CHANNEL",
  MUTATION_SET_IS_CONNECTING: "MUTATION_SET_IS_CONNECTING",
  MUTATION_SET_CURRENT_CHANNEL_MESSAEGS: "MUTATION_SET_CURRENT_CHANNEL_MESSAEGS"
};

export const getterTypes = {
  GETTER_MESSAGES: "GETTER_MESSAGES",
  GETTER_CHANNELS: "GETTER_CHANNELS",
  GETTER_SELECTED_CHANNEL: "GETTER_SELECTED_CHANNEL",
  GETTER_TYPING_MEMBER: "GETTER_TYPING_MEMBER",
  GETTER_IS_LOADING_MESSAGES: "GETTER_IS_LOADING_MESSAGES",
  GETTER_IS_CONNECTING: "GETTER_IS_CONNECTING"
};

const twillioChatState = {
  token: "",
  client: "",
  currentChannel: "",
  leaveAll: [],
  conversations: [],
  managers: []
};

export default {
  moduleName,

  namespaced: true,

  state: () => ({
    messages: {},
    typingMember: "",
    channels: [],
    selectedChannel: null,
    isLoadingMessages: false,
    isConnecting: false
  }),

  actions: {
    async [actionTypes.ACTION_CONNECT]({ commit, dispatch, rootGetters }) {
      try {
        const loggedIn =
          rootGetters[
            `${authStore.moduleName}/${authStore.getterTypes.GETTER_IS_AUTHENTICATED}`
          ];
        if (!loggedIn) return;
        commit(mutationTypes.MUTATION_SET_IS_CONNECTING, true);
    
        await dispatch(actionTypes.ACTION_FETCH_TOKEN);
    
        const token = twillioChatState.token;
        const client = new Client(token);
        twillioChatState.client = client;
        client.on('stateChanged', state => {
          console.log(`Client state changed to ${state}`);
        });
    
        client.on('connectionStateChanged', state => {
          console.log(`Client connection state changed to ${state}`);
        });
    
        client.on('connectionError', error => {
          console.error('Connection error:', error);
        });
        client.on("conversationJoined", async conversation => {
          console.log("conversationJoined");
        });
    
        client.on("channelAdded", c => {
          console.log("channelAdded");
          // commit(mutationTypes.MUTATION_ADD_CHANNELS, c);
        });
    
        client.on("channelJoined", c => {
          console.log("channelJoined");
        });
    
        client.on("tokenExpired", () => {
          console.log("tokenExpired");
          dispatch(actionTypes.ACTION_REFRESH_TOKEN);
        });
    
        const loadChannels = async items => {
          const usernames = items.map(c => c.friendlyName);
          let { data: userAvatars } = await API.user.getUsersAvatar({
            usernames
          });
    
          userAvatars = userAvatars.reduce((acc, item) => {
            acc[item.username] = item.avatar;
            return acc;
          }, {});
    
          for (const c of items) {
            let totalUnreadMessageCount = 0;
            if (c.attributes && c.attributes.totalUnreadMessageCount) {
              totalUnreadMessageCount = c.attributes.totalUnreadMessageCount;
            }
            let attributes = await c.getAttributes();
            if(attributes && attributes.lastMsg && attributes.lastMsg.dateCreated){
              c.lastMsg = {
                dateCreated: attributes?.lastMsg?.dateCreated,
                message: attributes?.lastMsg?.message
              };
            }
            c.id = c.sid;
            c.username = c.friendlyName;
            c.unreadCount = totalUnreadMessageCount;
            c.userAvatar = userAvatars[c.friendlyName];
           
          }
          return items.filter(c => !c.friendlyName.includes("manager_"));
        };
    
        const loadPublicChannels = async (channels, paginator) => {
          if (paginator.hasNextPage) {
            try {
              const nextPaginator = await paginator.nextPage();
              return loadPublicChannels(
                [...channels, ...nextPaginator.items],
                nextPaginator
              );
            } catch (err) {
              console.log("Error loading public channels", err);
            }
          } else {
            return channels;
          }
        };
    
        console.log("client", client);
        let channels = [];
        try {
          channels = await client.getSubscribedConversations();
          console.log("getSubscribedConversations channels", channels);
        } catch (err) {
          console.log("Error in getting subscribed channels by user", err);
        }
        if(channels && channels.items){
          try {
            channels = await loadPublicChannels([...channels.items], channels);
            console.log("public channels", channels);
          } catch (err) {
            console.log("Error in loading public channels", err);
          }
        }
       
    
        let loadedChannels = [];
        try {
          if (
            (channels && channels.length > 0) ||
            (channels && channels.items && channels.items.length > 0)
          ) {
            loadedChannels = await loadChannels(channels);
            console.log("loadedChannels channels", loadedChannels);
          }
          twillioChatState.conversations = loadedChannels;
        } catch (error) {
          console.log("Error in loading channels", error);
        }
    
        commit(mutationTypes.MUTATION_SET_CHANNELS, loadedChannels);
        commit(mutationTypes.MUTATION_SET_IS_CONNECTING, false);
  
        // Join to channels and save leave method
        const joinToChannel = async channel => {
          if (!channel) return;
  
          twillioChatState.currentChannel = channel;
  
          try {
            if (channel?.channelState?.status !== "joined") {
              await channel.join();
            }
          } catch (error) {}
  
          const onMessageAdded = message => {
            console.log("onMessageAdded", message)
            commit(
              mutationTypes.MUTATION_ADD_MESSAGE_TO_CHANNEL,
              message.conversation.sid
            );
          };
          const onStartTyping = member => {};
          const onEndTyping = () => {};
          const onMemberJoined = member => {};
          const onMemberLeft = member => {};
  
          channel.on(twillioChannelEvents.EVENT_MESSAGE_ADDED, onMessageAdded);
          channel.on(twillioChannelEvents.EVENT_TYPING_STARTED, onStartTyping);
          channel.on(twillioChannelEvents.EVENT_TYPYING_ENDED, onEndTyping);
          channel.on(twillioChannelEvents.EVENT_MEMBER_JOINED, onMemberJoined);
          channel.on(twillioChannelEvents.EVENT_MEMBER_LEFT, onMemberLeft);
        };
  
        const joinToChannelsPromises = loadedChannels.map(c => joinToChannel(c));
        const leaveFns = await Promise.allSettled(joinToChannelsPromises);
  
        twillioChatState.leaveAll = leaveFns
          .filter(s => s.status === "fulfilled")
          .map(s => s.value);
      }catch(err){
        console.log("Error in connection support", err)
      }
     
    },

    async [actionTypes.ACTION_DISCONNECT]({ commit }) {
      if (twillioChatState.leaveAll) {
        twillioChatState.leaveAll.forEach(l => {
          l?.leave?.();
        });
      }

      commit(mutationTypes.MUTATION_SET_SELECTED_CHANNEL, null);
      commit(mutationTypes.MUTATION_SET_CHANNELS, []);
    },
    async [actionTypes.ACTION_READ_MESSAGE](
      { commit, getters, dispatch },
      { conversation, messageIndex }
    ) {
      console.log("ACTION_READ_MESSAGE conversation",conversation)
      const channel = await twillioChatState.client.getConversationBySid(conversation.sid);

      const currentAttributes = await channel.getAttributes();
      console.log("currentAttributes",currentAttributes)
      const updatedAttributes = {
        ...currentAttributes,
        totalUnreadMessageCount: 0,
      };
      channel.updateAttributes(updatedAttributes)
      channel.updateLastReadMessageIndex(messageIndex);
      commit(mutationTypes.MUTATION_UPDATE_CHANNEL, [
        conversation.sid,
        { unreadCount: 0 }
      ]);
    },
    async [actionTypes.ACTION_SELECT_CHANNEL](
      { commit, getters, dispatch },
      sid
    ) {
      const channel = getters[getterTypes.GETTER_CHANNELS].find(
        c => c.sid === sid
      );
      if (!channel) return;
      
      // const loadPublicChannels = async (channels, paginator) => {
      //   if (paginator.hasNextPage) {
      //     try{
      //       const nextPaginator = await paginator.nextPage();
      //       return loadPublicChannels(
      //         [...channels, ...nextPaginator.items],
      //         nextPaginator
      //       );
      //     }catch(err){
      //       console.log("err", err)
      //     } 
      //   } else {
      //     return channels;
      //   }
      // };
      // let converations = await twillioChatState.client.getSubscribedConversations();
      // try{
      //   converations = await loadPublicChannels([...converations.items], converations)
      // }catch(err){
      //   console.log("err", err)
      // }
      const _channel = await await twillioChatState.client.getConversationBySid(sid);

      twillioChatState.currentChannel = _channel;

      const onMessageAdded = async message => {
        await _channel.getMessages();
        commit(mutationTypes.MUTATION_ADD_MESSAGE, [message]);
      };
      const onStartTyping = member =>
        commit(mutationTypes.MUTATION_SET_TYPING_MEMBER, member);
      const onEndTyping = () =>
        commit(mutationTypes.MUTATION_UNSET_TYPING_MEMBER);
      const onMemberJoined = member =>
        commit(mutationTypes.MUTATION_SET_TYPING_MEMBER, member);
      const onMemberLeft = member =>
        commit(mutationTypes.MUTATION_SET_TYPING_MEMBER, member);

      _channel.on(twillioChannelEvents.EVENT_MESSAGE_ADDED, onMessageAdded);
      _channel.on(twillioChannelEvents.EVENT_TYPING_STARTED, onStartTyping);
      _channel.on(twillioChannelEvents.EVENT_TYPYING_ENDED, onEndTyping);
      _channel.on(twillioChannelEvents.EVENT_MEMBER_JOINED, onMemberJoined);
      _channel.on(twillioChannelEvents.EVENT_MEMBER_LEFT, onMemberLeft);

      commit(mutationTypes.MUTATION_UNSET_MESSAGES);
      commit(mutationTypes.MUTATION_SET_SELECTED_CHANNEL, channel);

      twillioChatState.currentChannel = _channel;

      // try {
      //   await _channel.getMessages();
      // } catch (error) {}

      const messages = await _channel.getMessages();
      let totalMessasges = []
      const getMessages = async messages => {
        if (totalMessasges.length === 0) {
          totalMessasges = messages.items;
        } else {
          let newMessags = messages.items
          totalMessasges = newMessags.concat(totalMessasges);
        }

        if (messages.hasPrevPage) {
          let nextMessages = await messages.prevPage();
          getMessages(nextMessages);
        } else {
          if (totalMessasges && totalMessasges.length) {
            totalMessasges.forEach(m => {
              commit(mutationTypes.MUTATION_ADD_MESSAGE, [m, channel.userAvatar]);
            });
          }
          dispatch(actionTypes.ACTION_READ_MESSAGE, { conversation: _channel,messageIndex: totalMessasges.length })
          commit(mutationTypes.MUTATION_UPDATE_CHANNEL, [
            _channel.sid,
            { unreadCount: 0 }
          ]);
        }
      };
      getMessages(messages)
      
    },

    async [actionTypes.ACTION_FETCH_TOKEN]({ rootGetters }) {
      const user =
        rootGetters[
          `${authStore.moduleName}/${authStore.getterTypes.GETTER_USER}`
        ];
      // const res = await API.support.getAccessToken(`manager_${user?.username}`);
      debugger
      const res = await API.support.getAccessToken(process.env.VUE_APP_SUPPORT_ADMIN);
      twillioChatState.token = res.data.token;
    },
    async [actionTypes.ACTION_FETCH_MANAGERS]({ commit }) {
      const res = await API.support.getManagers.call(this);
      twillioChatState.managers = res.data;
    },
    async [actionTypes.ACTION_LEAVE_CURRENT_CHANNEL](
      { commit },
      unset = false
    ) {
      if (!twillioChatState.currentChannel) return;
      if (unset) commit(mutationTypes.MUTATION_SET_SELECTED_CHANNEL, null);

      const currentChannel = twillioChatState.currentChannel?.channelState
        ? twillioChatState.currentChannel
        : await twillioChatState.currentChannel.getChannel();

      if (currentChannel?.leave) {
        return await currentChannel.leave();
      }
    },

    async [actionTypes.ACTION_REFRESH_TOKEN]({ dispatch }) {
      await dispatch(actionTypes.ACTION_FETCH_TOKEN);
      const token = twillioChatState.token;
      const client = twillioChatState.client;

      if (client?.updateToken) {
        client.updateToken(token);
      }
    },
    async [actionTypes.ACTION_LOAD_MESSAGES]({ commit, getters }) {
      const messages = await twillioChatState.currentChannel.getMessages();
      let totalMessasges = []
      const getMessages = async messages => {
        if (totalMessasges.length === 0) {
          totalMessasges = messages.items;
        } else {
          let newMessages = messages.items
          totalMessasges = newMessages.concat(totalMessasges);
        }

        if (messages.hasPrevPage) {
          let nextMessages = await messages.prevPage();
          getMessages(nextMessages);
        } else {
          if (totalMessasges) {
            let messgs = [];
            totalMessasges.forEach(m => {
              messgs.push(m);
              commit(mutationTypes.MUTATION_ADD_MESSAGE, [m]);
            });
          }
        }
      };
      getMessages(messages)
    },
    async [actionTypes.ACTION_SEND_MESSAGE](
      { getters, dispatch },
      { message, username }
    ) {
      debugger
      const currentChannel = twillioChatState.currentChannel;
      const channel = await twillioChatState.client.getConversationBySid(currentChannel.sid);
      
      if (currentChannel && currentChannel.sendMessage) {
        let unreadMessageCount = 0
        if(currentChannel.attributes && currentChannel.attributes.totalUnreadMessageCount){
          unreadMessageCount = currentChannel.attributes.totalUnreadMessageCount + 1
        }else{
          unreadMessageCount = 1
        }
        const currentAttributes = await channel.getAttributes();
      const updatedAttributes = {
        ...currentAttributes,
        totalUnreadMessageCount: unreadMessageCount,
        unreadCount: unreadMessageCount,
        lastMsg: {
          message: message,
          dateCreated: moment().toDate()
        }
      };
      await channel.updateAttributes(updatedAttributes)

        currentChannel.sendMessage(message);
        API.support.notifyUser(message, username);
        dispatch(actionTypes.ACTION_LOAD_MESSAGES);

      }
    },
    async [actionTypes.ACTION_DELETE_MESSAGE]({ commit, getters, dispatch },{message}) {
     const currentChannel = twillioChatState.currentChannel;
     let messages = await currentChannel.getMessages();
     const getMessages = async messages => {
      if (totalMessasges.length === 0) {
        totalMessasges = messages.items;
      } else {
        let newMessages = messages.items
        totalMessasges = newMessages.concat(totalMessasges);
      }

      if (messages.hasPrevPage) {
        let nextMessages = await messages.prevPage();
        getMessages(nextMessages);
      } else {
        let unreadMessageCount = 0;
        if (totalMessasges && totalMessasges.length > 0) {
          if (c.lastReadMessageIndex) {
            let totalUnreadMessages = totalMessasges.slice(
              c.lastReadMessageIndex,
              totalMessasges.length - 1
            );
            unreadMessageCount = totalUnreadMessages.length;
          } else {
            unreadMessageCount = totalMessasges.length;
          }
        }
        c.id = c.sid;
        c.username = c.friendlyName;
        c.unreadCount = unreadMessageCount;
        c.userAvatar = userAvatars[c.friendlyName];
      }
    };
    messages = messages.items
    debugger
     let findMessageIndex = messages.findIndex(m => m.sid === message.id)
     let findMessage = messages[findMessageIndex]
     try{
      await findMessage.remove();
      dispatch(actionTypes.ACTION_LOAD_MESSAGES);
      let updatedMessages = messages.splice(findMessageIndex, 1);
      commit(mutationTypes.MUTATION_SET_CURRENT_CHANNEL_MESSAEGS, messages )
      return true
     }catch(err){
      console.log("err", err)
      if (err.response) {
        console.error("Error response status:", err.response.status);
        console.error("Error response data:", err.response.data);
      }
     }
     
    },
    async [actionTypes.ACTION_DELETE_CHANNEL]({ commit, getters },{currentChannel}) {
      const channels = getters[getterTypes.GETTER_CHANNELS];
      const currentChannelIndex = channels.findIndex(
        c => c.sid === currentChannel.sid
      );

      try {
        try{
          await currentChannel.delete();

        }catch(err){
          console.log("err", err)
        }

        if (currentChannelIndex >= 0) {
          const newChannels = channels.splice(currentChannelIndex, 1);
          commit(mutationTypes.MUTATION_SET_CHANNELS, channels);
          commit(mutationTypes.MUTATION_SET_SELECTED_CHANNEL, null);
        }
      } catch (error) {
        console.log(error);
      }
    }
  },

  mutations: {
    [mutationTypes.MUTATION_ADD_MESSAGE](state, [message, icon]) {
      if (message?.conversation?.sid !== state?.selectedChannel?.sid) return;
      if (state.messages.some(m => m.id === message.state.sid)) return;

      state.messages.push({
        id: message.state.sid,
        username: message.author,
        date: moment(message.dateCreated).toDate(),
        body: message.body,
        isManager: message.author !== state.selectedChannel.username,
        icon: icon
          ? icon
          : message.author === state.selectedChannel.username
          ? state.selectedChannel.userAvatar
          : ""
      });
    },
    [mutationTypes.MUTATION_UPDATE_CHANNEL](state, [sid, value]) {
      const channelIndex = state.channels.findIndex(c => c.id === sid);
      if (channelIndex >= 0) {
        state.channels.splice(channelIndex, 1, {
          ...state.channels[channelIndex],
          ...value
        });
      }
    },
    async [mutationTypes.MUTATION_ADD_MESSAGE_TO_CHANNEL](state, sid) {
      debugger
      const channelIndex = state.channels.findIndex(c => c.id === sid);
      console.log("current channel", state.selectedChannel)
      //  if(channelIndex > -1){
      //   const channel = await twillioChatState.client.getConversationBySid(state.channels[channelIndex].sid);
      //   const currentAttributes = await channel.getAttributes();
      //   const updatedAttributes = {
      //    ...currentAttributes,
      //    totalUnreadMessageCount: state.channels[channelIndex].unreadCount + 1,
      //    unreadCount: state.channels[channelIndex].unreadCount + 1,
      //    lastMsg: {
      //      message: "",
      //      dateCreated: moment().toDate()
      //    }
      //  };
      //  console.log("updatedAttributes",updatedAttributes)
      //  await channel.updateAttributes(updatedAttributes)
      //  state.channels[channelIndex] = channel
      //  }
      if (channelIndex >= 0) {
        state.channels.splice(channelIndex, 1, {
          ...state.channels[channelIndex],
          unreadCount: state.selectedChannel && state.selectedChannel.sid === state.channels[channelIndex].sid ? 0 : state.selectedChannel && state.selectedChannel.sid !== state.channels[channelIndex].sid ? state.channels[channelIndex].unreadCount + 1 : !state.selectedChannel ? state.channels[channelIndex].unreadCount + 1: 0,
          lastMsg: {
            ...state.channels[channelIndex].lastMsg,
            dateCreated: moment().toDate()
          }
        });
      }
    },
    [mutationTypes.MUTATION_SET_SELECTED_CHANNEL](state, channel) {
      state.selectedChannel = channel;
    },
    [mutationTypes.MUTATION_UNSET_MESSAGES](state) {
      state.messages = [];
    },
    [mutationTypes.MUTATION_SET_TYPING_MEMBER](state, member) {
      state.typingMember = member.identity;
    },
    [mutationTypes.MUTATION_UNSET_TYPING_MEMBER](state) {
      state.typingMember = "";
    },
    [mutationTypes.MUTATION_ADD_CHANNELS](state, channel) {
      state.channels.push(channel);
    },
    [mutationTypes.MUTATION_SET_CURRENT_CHANNEL_MESSAEGS](state, messages) {
      state.messages = messages;
    },
    [mutationTypes.MUTATION_SET_CHANNELS](state, channels) {
      state.channels = channels;
    },
    [mutationTypes.MUTATION_SET_IS_CONNECTING](state, v) {
      state.isConnecting = v;
    }
  },

  getters: {
    [getterTypes.GETTER_MESSAGES]: state => state.messages,
    [getterTypes.GETTER_TYPING_MEMBER]: state => state.typingMember,
    [getterTypes.GETTER_CHANNELS]: state => state.channels,
    [getterTypes.GETTER_IS_LOADING_MESSAGES]: state => state.isLoadingMessages,
    [getterTypes.GETTER_IS_CONNECTING]: state => state.isConnecting,
    [getterTypes.GETTER_SELECTED_CHANNEL]: state => state.selectedChannel
  }
};
